import React, { useCallback } from 'react'
import { AppSvg, Button, FormattedHTMLMessage, newIcons, useBreakpoints } from '@web/walter-ui-kit'

import { GetCard } from '@web/walter-lib/api'
import cn from 'classnames'
import { CardsViews } from '../../types'
import { lang } from './lang'
import s from './s.module.css'
import PageHeader from '~components/PageLayout/PageHeader'
import { useCards, useGetThreeDSChallengesData, useProducts } from '~api'

interface Props {
    view: CardsViews
    setView: (newView: CardsViews) => void
    setCardsListModal: (arg: { isOpen: boolean }) => void
    selectedCard?: GetCard
}

function HeaderTitle({ view }: Pick<Props, 'view'>) {
    if (view === CardsViews.NewCard || view === CardsViews.NewCards) {
        return <FormattedHTMLMessage {...lang.getNewCard} />
    }

    return <FormattedHTMLMessage {...lang.cards} />
}

// eslint-disable-next-line complexity
function Header({ view, setView, selectedCard, setCardsListModal }: Props) {
    const { data: cards } = useCards()
    const { data: products } = useProducts()
    const { data: chData } = useGetThreeDSChallengesData()

    const { isMobile, isTablet } = useBreakpoints()

    const onBackClick = useCallback(() => {
        if (view === CardsViews.NewCards) {
            if (cards?.cards && cards?.cards.length > 0) {
                return setView(CardsViews.Cards)
            }
            return setView(CardsViews.NoCards)
        }
        if (view === CardsViews.NewCard) {
            return setView(CardsViews.NewCards)
        }
    }, [cards?.cards, setView, view])

    const isSmallView = isMobile || isTablet

    return (
        <PageHeader
            rootPage={!isMobile && !isTablet && view !== CardsViews.NewCard && view !== CardsViews.NewCards}
            onBackClick={view !== CardsViews.NoCards ? onBackClick : undefined}
            withBackButton={!(view === CardsViews.Cards)}
            title={
                <div className={s.title}>
                    {!(isSmallView && view === CardsViews.Cards) && <HeaderTitle view={view} />}
                    {isSmallView && view === CardsViews.Cards && (
                        <div onClick={() => setCardsListModal({ isOpen: true })} className="cursor-pointer relative">
                            <AppSvg svgName={newIcons.ic24BurgerMenu} path="new-icons" size={24} />
                            <div
                                className={cn(
                                    'w-[8px] h-[8px] rounded-full bg-text-negative absolute top-[2px] right-0',
                                    chData?.challenges && chData?.challenges?.length > 0 ? 'block' : 'hidden'
                                )}
                            />
                        </div>
                    )}
                    {!isSmallView &&
                        products?.products &&
                        products?.products?.length > 0 &&
                        view === CardsViews.Cards && (
                            <Button
                                prefix={<AppSvg svgName={newIcons.ic24Card} path="new-icons" size={16} />}
                                dataPointer="new_card"
                                size="s"
                                mode="primary"
                                onClick={() => setView(CardsViews.NewCards)}
                            >
                                <FormattedHTMLMessage {...lang.getNewCard} />
                            </Button>
                        )}
                </div>
            }
            center={
                view === CardsViews.Cards && (
                    <FormattedHTMLMessage {...lang.card} values={{ numbers: `••${selectedCard?.masked_number}` }} />
                )
            }
            right={
                isSmallView &&
                products?.products &&
                products?.products?.length > 0 &&
                view === CardsViews.Cards && (
                    <div onClick={() => setView(CardsViews.NewCards)} className="cursor-pointer">
                        <AppSvg svgName={newIcons.ic24Plus} path="new-icons" size={24} />
                    </div>
                )
            }
        />
    )
}

export default Header
